import React, { forwardRef, type KeyboardEvent, type MouseEvent, useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

import { RouterLink } from './styled';
import { type LinkProps } from './types';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { analyticsItemId, onClick, ...restProps } = props;

	const onClickWithAnalytics = useCallback(
		(e: MouseEvent | KeyboardEvent) => {
			const analyticsEvent = createAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'navigationItem',
			});

			fireUIAnalytics(analyticsEvent, 'sidebar', {
				itemId: analyticsItemId,
			});
			onClick?.(e);
		},
		[createAnalyticsEvent, analyticsItemId, onClick],
	);

	return (
		<RouterLink
			{...restProps}
			onClick={onClickWithAnalytics}
			ref={ref}
			type={props.href != null || props.to != null ? 'a' : 'button'}
			aria-current={props.isSelected}
		/>
	);
});
